/** Lao text for the direct booking engine: settings tabs, readiness checks and the guest preview. */
export const laoHotelBookingEngine: Record<string, string> = {
  'Welcome back': 'ຍິນດີຕ້ອນຮັບອີກຄັ້ງ',
  'Sign in': 'ເຂົ້າສູ່ລະບົບ',
  'Google sign-in has not been set up for this booking page yet.':
    'ຍັງບໍ່ໄດ້ຕັ້ງຄ່າການເຂົ້າສູ່ລະບົບ Google ສໍາລັບໜ້າຈອງນີ້.',
  'Google sign-in is not available for this property yet. You can still book as a guest.':
    'ການເຂົ້າສູ່ລະບົບ Google ຍັງບໍ່ພ້ອມສໍາລັບໂຮງແຮມນີ້. ທ່ານຍັງສາມາດຈອງໂດຍບໍ່ໃຊ້ບັນຊີໄດ້.',
  'Enter your details below. Google sign-in is unavailable for this property.':
    'ປ້ອນຂໍ້ມູນຂອງທ່ານຂ້າງລຸ່ມ. ການເຂົ້າສູ່ລະບົບ Google ຍັງບໍ່ພ້ອມສໍາລັບໂຮງແຮມນີ້.',
  'Sign out': 'ອອກຈາກລະບົບ',
  or: 'ຫຼື',
  'Sign-in is unavailable. Please try again.': 'ບໍ່ສາມາດເຂົ້າສູ່ລະບົບໄດ້. ກະລຸນາລອງໃໝ່.',
  'Google sign-in is unavailable. You can continue as a guest.':
    'ບໍ່ສາມາດໃຊ້ Google ໄດ້ໃນຂະນະນີ້. ທ່ານສາມາດສືບຕໍ່ໂດຍບໍ່ໃຊ້ບັນຊີ.',
  'Unable to sign out. Please try again.': 'ບໍ່ສາມາດອອກຈາກລະບົບໄດ້. ກະລຸນາລອງໃໝ່.',
  'Allow storage for this website to keep your stay while signing in, or continue as a guest.':
    'ອະນຸຍາດໃຫ້ເວັບໄຊນີ້ເກັບຂໍ້ມູນເພື່ອຮັກສາການເຂົ້າພັກໃນລະຫວ່າງເຂົ້າສູ່ລະບົບ ຫຼື ສືບຕໍ່ໂດຍບໍ່ໃຊ້ບັນຊີ.',
  'Your account': 'ບັນຊີຂອງທ່ານ',
  'Google sign-in was cancelled. You can continue as a guest.':
    'ຍົກເລີກການເຂົ້າສູ່ລະບົບ Google ແລ້ວ. ທ່ານສາມາດສືບຕໍ່ໂດຍບໍ່ໃຊ້ບັນຊີ.',
  'Google sign-in could not be completed. Try again or continue as a guest.':
    'ບໍ່ສາມາດເຂົ້າສູ່ລະບົບ Google ໄດ້. ລອງໃໝ່ ຫຼື ສືບຕໍ່ໂດຍບໍ່ໃຊ້ບັນຊີ.',
  'Your selected stay changed. Please choose a room again.':
    'ການເຂົ້າພັກທີ່ທ່ານເລືອກມີການປ່ຽນແປງ. ກະລຸນາເລືອກຫ້ອງອີກຄັ້ງ.',
  'Direct booking': 'ຈອງໂດຍກົງ',
  'Your guest account': 'ບັນຊີແຂກຂອງທ່ານ',
  'A smoother arrival': 'ເຂົ້າພັກໄດ້ສະດວກຂຶ້ນ',
  'Your stay starts here': 'ເລີ່ມການເຂົ້າພັກຂອງທ່ານທີ່ນີ້',
  'Your Google account is connected to this property.':
    'ບັນຊີ Google ຂອງທ່ານເຊື່ອມຕໍ່ກັບໂຮງແຮມນີ້ແລ້ວ.',
  'Sign in to fill your guest details and continue your conversations on any device.':
    'ເຂົ້າສູ່ລະບົບເພື່ອຕື່ມຂໍ້ມູນແຂກ ແລະ ສືບຕໍ່ການສົນທະນາຈາກທຸກອຸປະກອນ.',
  'Signed in with Google': 'ເຂົ້າສູ່ລະບົບດ້ວຍ Google ແລ້ວ',
  'Verified account': 'ບັນຊີທີ່ຢືນຢັນແລ້ວ',
  'Continue booking': 'ສືບຕໍ່ການຈອງ',
  'Signing out…': 'ກຳລັງອອກຈາກລະບົບ…',
  'Signing out clears your details from this booking page. Your account stays available for your next visit.':
    'ການອອກຈາກລະບົບຈະລຶບຂໍ້ມູນຂອງທ່ານອອກຈາກໜ້າຈອງນີ້. ທ່ານຍັງສາມາດໃຊ້ບັນຊີໃນຄັ້ງຕໍ່ໄປ.',
  'Fill your name and email in one step': 'ຕື່ມຊື່ ແລະ ອີເມວໃນຂັ້ນຕອນດຽວ',
  'Keep your hotel conversations together': 'ເກັບການສົນທະນາກັບໂຮງແຮມໄວ້ຮ່ວມກັນ',
  'Continue with Google': 'ສືບຕໍ່ດ້ວຍ Google',
  'Connecting to Google…': 'ກຳລັງເຊື່ອມຕໍ່ Google…',
  'Only your basic profile and email are shared.': 'ແບ່ງປັນພຽງຂໍ້ມູນພື້ນຖານ ແລະ ອີເມວຂອງທ່ານ.',
  'Continue as a guest': 'ສືບຕໍ່ໂດຍບໍ່ໃຊ້ບັນຊີ',
  'No account is needed to reserve a room.': 'ສາມາດຈອງຫ້ອງໄດ້ໂດຍບໍ່ຕ້ອງມີບັນຊີ.',
  'Preparing secure sign-in…': 'ກຳລັງກຽມການເຂົ້າສູ່ລະບົບ…',
  'Spend less time on the details': 'ຕື່ມຂໍ້ມູນໄດ້ໄວຂຶ້ນ',
  'Use Google to fill your name and email, or enter them below.':
    'ໃຊ້ Google ເພື່ອຕື່ມຊື່ ແລະ ອີເມວ ຫຼື ຕື່ມຂໍ້ມູນຂ້າງລຸ່ມ.',
  'You are signed in. Review your stay and guest details before booking.':
    'ເຂົ້າສູ່ລະບົບແລ້ວ. ກວດກາການເຂົ້າພັກ ແລະ ຂໍ້ມູນແຂກກ່ອນຈອງ.',
  'Checking your sign-in…': 'ກຳລັງກວດກາການເຂົ້າສູ່ລະບົບ…',
  'Google sign-in was cancelled. Your stay is saved and you can continue as a guest.':
    'ຍົກເລີກການເຂົ້າສູ່ລະບົບ Google ແລ້ວ. ຂໍ້ມູນການເຂົ້າພັກຖືກເກັບໄວ້ ແລະ ທ່ານສາມາດສືບຕໍ່ໂດຍບໍ່ໃຊ້ບັນຊີ.',
  'Google sign-in could not be completed. Your stay is saved. Try again or continue as a guest.':
    'ບໍ່ສາມາດເຂົ້າສູ່ລະບົບ Google ໄດ້. ຂໍ້ມູນການເຂົ້າພັກຖືກເກັບໄວ້. ລອງໃໝ່ ຫຼື ສືບຕໍ່ໂດຍບໍ່ໃຊ້ບັນຊີ.',
  'Your selected room is no longer available. Please choose another room.':
    'ຫ້ອງທີ່ທ່ານເລືອກບໍ່ວ່າງແລ້ວ. ກະລຸນາເລືອກຫ້ອງອື່ນ.',
  'View rates': 'ເບິ່ງລາຄາ',
  'Flexible dates': 'ວັນທີຢືດຢຸ່ນ',
  'View calendar rates': 'ເບິ່ງລາຄາໃນປະຕິທິນ',
  'Coral · Default': 'ສີປະກາລັງ · ຄ່າເລີ່ມຕົ້ນ',
  'Azure blue': 'ສີຟ້າສົດໃສ',
  'Bright blue booking with a photo gallery and clear room rates.':
    'ໜ້າຈອງສີຟ້າສົດໃສ ພ້ອມຮູບພາບ ແລະ ລາຄາຫ້ອງທີ່ຊັດເຈນ.',
  // Guest app themes
  'Booking theme': 'ຮູບແບບໜ້າຈອງ',
  'Charcoal & peach': 'ສີຖ່ານ ແລະ ສີພີດ',
  Classic: 'ຄລາສສິກ',
  'App-like navigation, photo cards and room details.': 'ເມນູແບບແອັບ ພ້ອມຮູບພາບ ແລະ ລາຍລະອຽດຫ້ອງ.',
  'A light booking page with your brand colors.': 'ໜ້າຈອງສີອ່ອນ ທີ່ໃຊ້ສີຂອງແບຣນທ່ານ.',
  'Saved rooms': 'ຫ້ອງທີ່ບັນທຶກໄວ້',
  'Booking navigation': 'ເມນູການຈອງ',
  Explore: 'ສຳຫຼວດ',
  'Explore room': 'ເບິ່ງລາຍລະອຽດຫ້ອງ',
  'All rooms': 'ຫ້ອງທັງໝົດ',
  'Save room': 'ບັນທຶກຫ້ອງ',
  'Remove saved room': 'ລຶບຫ້ອງທີ່ບັນທຶກ',
  'Share room': 'ແບ່ງປັນຫ້ອງ',
  'Room link copied': 'ຄັດລອກລິ້ງຫ້ອງແລ້ວ',
  'Unable to share. Copy the page address to share this room.':
    'ແບ່ງປັນບໍ່ໄດ້. ຄັດລອກທີ່ຢູ່ໜ້ານີ້ເພື່ອແບ່ງປັນຫ້ອງ.',
  'What we offer': 'ສິ່ງທີ່ມີໃຫ້',
  'Choose your rate': 'ເລືອກລາຄາຂອງທ່ານ',
  'Contact the property for room amenities and details.':
    'ຕິດຕໍ່ໂຮງແຮມເພື່ອສອບຖາມສິ່ງອຳນວຍຄວາມສະດວກ ແລະ ລາຍລະອຽດຫ້ອງ.',
  'Availability is checked for your selected dates.': 'ກວດຫ້ອງຫວ່າງຕາມວັນທີທີ່ທ່ານເລືອກ.',
  'Tap the heart on a room to save it here.': 'ກົດຮູບຫົວໃຈຢູ່ຫ້ອງເພື່ອບັນທຶກໄວ້ທີ່ນີ້.',
  'Booking progress': 'ຂັ້ນຕອນການຈອງ',
  'Choose a room': 'ເລືອກຫ້ອງ',
  'See available rooms': 'ເບິ່ງຫ້ອງທີ່ວ່າງ',
  'Your stay': 'ການພັກຂອງທ່ານ',
  'Explore property': 'ສຳຫຼວດໂຮງແຮມ',
  'room left': 'ຫ້ອງເຫຼືອ',
  'room type': 'ປະເພດຫ້ອງ',
  'room types': 'ປະເພດຫ້ອງ',
  Rooms: 'ຫ້ອງພັກ',
  'per room for full stay': 'ຕໍ່ຫ້ອງຕະຫຼອດການພັກ',
  'per room per night': 'ຕໍ່ຫ້ອງຕໍ່ຄືນ',
  'Availability updates automatically': 'ຂໍ້ມູນຫ້ອງຫວ່າງອັບເດດອັດຕະໂນມັດ',
  'Reconnecting to live availability…': 'ກຳລັງເຊື່ອມຕໍ່ຂໍ້ມູນຫ້ອງຫວ່າງໃໝ່…',
  'Updating availability…': 'ກຳລັງອັບເດດຫ້ອງຫວ່າງ…',
  'Total including taxes': 'ຍອດລວມພ້ອມພາສີ',
  Taxes: 'ພາສີ',
  'for your stay': 'ສຳລັບການພັກຂອງທ່ານ',
  'Cancellation terms: contact the property': 'ເງື່ອນໄຂການຍົກເລີກ: ຕິດຕໍ່ໂຮງແຮມ',
  'Review rooms and rates': 'ກວດເບິ່ງຫ້ອງ ແລະ ລາຄາ',
  'Retry this booking': 'ລອງການຈອງນີ້ອີກຄັ້ງ',
  'We could not verify the booking result. Retry this same booking to retrieve your confirmation safely.':
    'ຍັງຢືນຢັນຜົນການຈອງບໍ່ໄດ້. ລອງການຈອງເດີມອີກຄັ້ງ ເພື່ອຮັບການຢືນຢັນຢ່າງປອດໄພ.',
  'Your selected room or rate changed. Review availability before booking. Your guest details are saved on this page.':
    'ຫ້ອງ ຫຼື ລາຄາທີ່ທ່ານເລືອກປ່ຽນແປງແລ້ວ. ກະລຸນາກວດເບິ່ງຫ້ອງຫວ່າງກ່ອນຈອງ. ຂໍ້ມູນແຂກຍັງຢູ່ໃນໜ້ານີ້.',
  // Navigation and page heading
  'Booking engine': 'ລະບົບຈອງອອນລາຍ',
  'Booking engine sections': 'ພາກສ່ວນຂອງລະບົບຈອງອອນລາຍ',
  'Commission-free reservations from your own website, previewed as guests see them.':
    'ຮັບການຈອງຈາກເວັບໄຊຂອງທ່ານເອງ ໂດຍບໍ່ເສຍຄ່ານາຍໜ້າ ພ້ອມເບິ່ງຕົວຢ່າງແບບທີ່ແຂກເຫັນ',
  'Commission-free direct bookings': 'ການຈອງໂດຍກົງ ບໍ່ເສຍຄ່ານາຍໜ້າ',
  'Prices, availability and restrictions come from your rates. Changes are saved with your name in the activity log.':
    'ລາຄາ, ຫ້ອງຫວ່າງ ແລະ ຂໍ້ກຳນົດມາຈາກລາຄາຂອງທ່ານ. ການປ່ຽນແປງຈະບັນທຶກພ້ອມຊື່ຂອງທ່ານໃນປະຫວັດການໃຊ້ງານ',
  'You can view the booking engine. Ask a hotel administrator to make changes.':
    'ທ່ານເບິ່ງລະບົບຈອງອອນລາຍໄດ້. ກະລຸນາຂໍໃຫ້ຜູ້ດູແລໂຮງແຮມເປັນຜູ້ແກ້ໄຂ',
  'Booking engine saved': 'ບັນທຶກລະບົບຈອງອອນລາຍແລ້ວ',

  // Tabs
  Appearance: 'ຮູບແບບ',
  Accommodations: 'ຫ້ອງພັກ',
  Marketing: 'ການຕະຫຼາດ',
  Confirmation: 'ການຢືນຢັນ',
  Advanced: 'ຂັ້ນສູງ',

  // Overview
  'Take commission-free reservations from your own website. Review what guests see before you share your booking link.':
    'ຮັບການຈອງຈາກເວັບໄຊຂອງທ່ານເອງ ໂດຍບໍ່ເສຍຄ່ານາຍໜ້າ. ກວດເບິ່ງສິ່ງທີ່ແຂກເຫັນກ່ອນແບ່ງປັນລິ້ງຈອງ',
  'room types online': 'ປະເພດຫ້ອງທີ່ຂາຍອອນລາຍ',
  'rates online': 'ລາຄາທີ່ຂາຍອອນລາຍ',
  'add-ons offered': 'ລາຍການເສີມທີ່ສະເໜີ',
  languages: 'ພາສາ',
  'Ready to take bookings': 'ພ້ອມຮັບການຈອງ',
  'steps complete': 'ຂັ້ນຕອນສຳເລັດ',
  'Property address and contact': 'ທີ່ຢູ່ ແລະ ຂໍ້ມູນຕິດຕໍ່ຂອງໂຮງແຮມ',
  'Shown in the booking engine footer so guests can reach you.':
    'ສະແດງຢູ່ລຸ່ມສຸດຂອງໜ້າຈອງ ເພື່ອໃຫ້ແຂກຕິດຕໍ່ທ່ານໄດ້',
  'Property logo': 'ໂລໂກ້ໂຮງແຮມ',
  'Appears in the booking engine header.': 'ສະແດງຢູ່ສ່ວນຫົວຂອງໜ້າຈອງ',
  'Upload logo': 'ອັບໂຫຼດໂລໂກ້',
  'Every room type has a price': 'ທຸກປະເພດຫ້ອງມີລາຄາ',
  'Room types without a base rate cannot be sold online.':
    'ປະເພດຫ້ອງທີ່ບໍ່ມີລາຄາພື້ນຖານ ຂາຍອອນລາຍບໍ່ໄດ້',
  'Something to sell online': 'ມີສິ່ງທີ່ຂາຍອອນລາຍ',
  'Sell the standard rate, at least one rate plan, or both.':
    'ຂາຍລາຄາມາດຕະຖານ, ຢ່າງໜ້ອຍໜຶ່ງແຜນລາຄາ ຫຼື ທັງສອງຢ່າງ',
  'Default cancellation policy': 'ນະໂຍບາຍການຍົກເລີກເລີ່ມຕົ້ນ',
  'Guests see the cancellation terms of each rate before booking.':
    'ແຂກເຫັນເງື່ອນໄຂການຍົກເລີກຂອງແຕ່ລະລາຄາກ່ອນຈອງ',
  'Terms & conditions and privacy policy': 'ຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂ ແລະ ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ',
  'Each one adds a link to the booking engine footer.': 'ແຕ່ລະອັນຈະເພີ່ມລິ້ງຢູ່ລຸ່ມສຸດຂອງໜ້າຈອງ',
  'Guest booking link': 'ລິ້ງຈອງສຳລັບແຂກ',
  'Online reservations arrive as': 'ການຈອງອອນລາຍເຂົ້າມາເປັນ',
  'Check-in / check-out': 'ເຊັກອິນ / ເຊັກເອົ້າ',
  'Bookable up to': 'ຈອງລ່ວງໜ້າໄດ້ເຖິງ',
  'days ahead': 'ມື້ລ່ວງໜ້າ',
  'Same-day bookings until': 'ຈອງມື້ດຽວກັນໄດ້ເຖິງ',
  'Confirmation pending': 'ລໍຖ້າຢືນຢັນ',

  // Appearance
  'Match the booking engine to your brand. The preview updates as you type.':
    'ປັບລະບົບຈອງໃຫ້ເຂົ້າກັບແບຣນຂອງທ່ານ. ຕົວຢ່າງຈະອັບເດດທັນທີທີ່ພິມ',
  Headline: 'ຫົວຂໍ້',
  'Your website': 'ເວັບໄຊຂອງທ່ານ',
  'Your logo links here. Use a full https:// address.':
    'ໂລໂກ້ຈະລິ້ງມາບ່ອນນີ້. ໃຊ້ທີ່ຢູ່ເຕັມທີ່ເລີ່ມດ້ວຍ https://',
  'Welcome message': 'ຂໍ້ຄວາມຕ້ອນຮັບ',
  'Primary color': 'ສີຫຼັກ',
  'Buttons, selected dates and links.': 'ປຸ່ມ, ວັນທີທີ່ເລືອກ ແລະ ລິ້ງ',
  'Page background': 'ພື້ນຫຼັງໜ້າ',
  'Behind the search and room list.': 'ຢູ່ຫຼັງຊ່ອງຄົ້ນຫາ ແລະ ລາຍການຫ້ອງ',
  'No availability message': 'ຂໍ້ຄວາມເມື່ອບໍ່ມີຫ້ອງຫວ່າງ',
  'Shown when no room matches the guest’s dates and party.':
    'ສະແດງເມື່ອບໍ່ມີຫ້ອງທີ່ກົງກັບວັນທີ ແລະ ຈຳນວນແຂກ',
  'Show property logo': 'ສະແດງໂລໂກ້ໂຮງແຮມ',
  'Display your logo in the booking engine header.': 'ສະແດງໂລໂກ້ຂອງທ່ານຢູ່ສ່ວນຫົວຂອງໜ້າຈອງ',
  'Upload a logo in Property details to show it in the header.':
    'ອັບໂຫຼດໂລໂກ້ໃນຂໍ້ມູນໂຮງແຮມ ເພື່ອສະແດງຢູ່ສ່ວນຫົວ',

  // Filters
  'Choose how guests search and narrow the rooms they see.':
    'ເລືອກວິທີທີ່ແຂກຄົ້ນຫາ ແລະ ກັ່ນຕອງຫ້ອງທີ່ເຂົາເຈົ້າເຫັນ',
  'Guest occupancy filter': 'ຕົວກັ່ນຕອງຈຳນວນແຂກ',
  'Total guests': 'ຈຳນວນແຂກທັງໝົດ',
  'One field for everyone in the party.': 'ຊ່ອງດຽວສຳລັບທຸກຄົນໃນກຸ່ມ',
  'Adults and children': 'ຜູ້ໃຫຍ່ ແລະ ເດັກນ້ອຍ',
  'Separate fields for adults and children.': 'ແຍກຊ່ອງສຳລັບຜູ້ໃຫຍ່ ແລະ ເດັກນ້ອຍ',
  'Don’t ask': 'ບໍ່ຖາມ',
  'Hide the guest selector. Every room type is shown.': 'ເຊື່ອງຕົວເລືອກຈຳນວນແຂກ. ສະແດງທຸກປະເພດຫ້ອງ',
  'Start with 2 adults': 'ເລີ່ມຕົ້ນທີ່ຜູ້ໃຫຍ່ 2 ຄົນ',
  'Off starts with 1 adult, which shows the most room types.':
    'ຖ້າປິດ ຈະເລີ່ມທີ່ຜູ້ໃຫຍ່ 1 ຄົນ ເຊິ່ງສະແດງປະເພດຫ້ອງຫຼາຍທີ່ສຸດ',
  'Room type filter': 'ຕົວກັ່ນຕອງປະເພດຫ້ອງ',
  'Guests can pick a room type. Matching rooms move to the top; others stay bookable.':
    'ແຂກເລືອກປະເພດຫ້ອງໄດ້. ຫ້ອງທີ່ກົງກັນຈະຂຶ້ນກ່ອນ; ຫ້ອງອື່ນຍັງຈອງໄດ້',
  'Sort by price': 'ຮຽງຕາມລາຄາ',
  'Guests can order rooms and rates from low to high or high to low.':
    'ແຂກຮຽງຫ້ອງ ແລະ ລາຄາຈາກຕ່ຳຫາສູງ ຫຼື ສູງຫາຕ່ຳໄດ້',

  // Accommodations
  'How rooms, prices and rate plans appear, and how many rooms you sell online.':
    'ວິທີສະແດງຫ້ອງ, ລາຄາ ແລະ ແຜນລາຄາ ແລະ ຈຳນວນຫ້ອງທີ່ທ່ານຂາຍອອນລາຍ',
  'Display price': 'ການສະແດງລາຄາ',
  'Lowest nightly rate': 'ລາຄາຕໍ່ຄືນຕ່ຳສຸດ',
  'The cheapest night of the stay.': 'ຄືນທີ່ຖືກທີ່ສຸດຂອງການພັກ',
  'Total price for stay': 'ລາຄາລວມຂອງການພັກ',
  'Every night of the stay added together.': 'ລວມທຸກຄືນຂອງການພັກ',
  'Display rate plans': 'ການສະແດງແຜນລາຄາ',
  Collapsed: 'ຫຍໍ້',
  'Show the best rate; guests open the other offers.':
    'ສະແດງລາຄາທີ່ດີທີ່ສຸດ; ແຂກເປີດເບິ່ງຂໍ້ສະເໜີອື່ນໄດ້',
  Expanded: 'ຂະຫຍາຍ',
  'Show every rate of each room type.': 'ສະແດງທຸກລາຄາຂອງແຕ່ລະປະເພດຫ້ອງ',
  'Show currency on prices': 'ສະແດງສະກຸນເງິນກັບລາຄາ',
  'Display LAK next to every price.': 'ສະແດງ LAK ຂ້າງທຸກລາຄາ',
  'Include taxes in prices': 'ລວມອາກອນໃນລາຄາ',
  'Show the final price with your default invoice tax':
    'ສະແດງລາຄາສຸດທ້າຍ ລວມອາກອນໃບແຈ້ງໜີ້ເລີ່ມຕົ້ນຂອງທ່ານ',
  'Sell the standard rate': 'ຂາຍລາຄາມາດຕະຖານ',
  'Offer each room type at its base rate, next to your rate plans.':
    'ສະເໜີແຕ່ລະປະເພດຫ້ອງໃນລາຄາພື້ນຖານ ຄຽງຄູ່ກັບແຜນລາຄາຂອງທ່ານ',
  'Show sold-out rooms': 'ສະແດງຫ້ອງທີ່ເຕັມແລ້ວ',
  'Let guests browse room types that have no rooms left for their dates.':
    'ໃຫ້ແຂກເບິ່ງປະເພດຫ້ອງທີ່ບໍ່ມີຫ້ອງຫວ່າງໃນວັນທີທີ່ເລືອກ',
  'Limit online inventory': 'ຈຳກັດຈຳນວນຫ້ອງທີ່ຂາຍອອນລາຍ',
  'Keep some rooms for the front desk and other channels. 0 hides the room type online.':
    'ເກັບບາງຫ້ອງໄວ້ໃຫ້ຝ່າຍຕ້ອນຮັບ ແລະ ຊ່ອງທາງອື່ນ. 0 ຈະເຊື່ອງປະເພດຫ້ອງນັ້ນອອນລາຍ',
  'Sellable online': 'ຂາຍອອນລາຍໄດ້',
  'Limit rooms per booking': 'ຈຳກັດຈຳນວນຫ້ອງຕໍ່ການຈອງ',
  'The most rooms of one type a guest can reserve in a single booking.':
    'ຈຳນວນຫ້ອງສູງສຸດຂອງປະເພດດຽວ ທີ່ແຂກຈອງໄດ້ໃນການຈອງໜຶ່ງຄັ້ງ',
  'Per booking': 'ຕໍ່ການຈອງ',
  'Rate plans sold online': 'ແຜນລາຄາທີ່ຂາຍອອນລາຍ',
  'Manage rate plans': 'ຈັດການແຜນລາຄາ',
  Online: 'ອອນລາຍ',
  'No active rate plans yet.': 'ຍັງບໍ່ມີແຜນລາຄາທີ່ໃຊ້ງານ',

  // Guest details
  'Choose what guests tell you when they book. Each booking creates or updates a guest profile.':
    'ເລືອກຂໍ້ມູນທີ່ແຂກແຈ້ງເມື່ອຈອງ. ແຕ່ລະການຈອງຈະສ້າງ ຫຼື ອັບເດດໂປຣໄຟລ໌ແຂກ',
  'Always required': 'ຕ້ອງການສະເໝີ',
  'Require phone number': 'ບັງຄັບເບີໂທ',
  'Phone is always asked. Turn this on to make it required.':
    'ຖາມເບີໂທສະເໝີ. ເປີດເພື່ອບັງຄັບໃຫ້ປ້ອນ',
  'Guests choose their country.': 'ແຂກເລືອກປະເທດຂອງເຂົາເຈົ້າ',
  Gender: 'ເພດ',
  'Guests can tell you their gender.': 'ແຂກແຈ້ງເພດຂອງເຂົາເຈົ້າໄດ້',
  'Guest tax ID': 'ເລກປະຈຳຕົວຜູ້ເສຍອາກອນຂອງແຂກ',
  'Optional, for guests who need it on their invoice.': 'ບໍ່ບັງຄັບ, ສຳລັບແຂກທີ່ຕ້ອງການໃນໃບແຈ້ງໜີ້',
  'Company name': 'ຊື່ບໍລິສັດ',
  'Optional, for business travelers.': 'ບໍ່ບັງຄັບ, ສຳລັບນັກເດີນທາງທຸລະກິດ',
  'Company tax ID': 'ເລກປະຈຳຕົວຜູ້ເສຍອາກອນຂອງບໍລິສັດ',
  'Optional, for company invoices.': 'ບໍ່ບັງຄັບ, ສຳລັບໃບແຈ້ງໜີ້ບໍລິສັດ',
  'Estimated arrival time': 'ເວລາມາເຖິງໂດຍປະມານ',
  'Helps the front desk plan check-ins.': 'ຊ່ວຍໃຫ້ຝ່າຍຕ້ອນຮັບວາງແຜນເຊັກອິນ',
  'Require terms and conditions': 'ບັງຄັບຍອມຮັບຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂ',
  'Guests tick a box to accept your terms before booking.':
    'ແຂກໝາຍຖືກເພື່ອຍອມຮັບເງື່ອນໄຂຂອງທ່ານກ່ອນຈອງ',
  'Terms & conditions': 'ຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂ',
  'Adds a Terms & conditions link to the footer when filled in.':
    'ເມື່ອປ້ອນແລ້ວ ຈະເພີ່ມລິ້ງຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂຢູ່ລຸ່ມສຸດຂອງໜ້າ',
  'Privacy policy': 'ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ',
  'Adds a Privacy policy link to the footer when filled in.':
    'ເມື່ອປ້ອນແລ້ວ ຈະເພີ່ມລິ້ງນະໂຍບາຍຄວາມເປັນສ່ວນຕົວຢູ່ລຸ່ມສຸດຂອງໜ້າ',

  // Marketing
  'Ask guests for consent before you send them offers. Guests who skip the question are not opted in.':
    'ຂໍຄວາມຍິນຍອມຈາກແຂກກ່ອນສົ່ງຂໍ້ສະເໜີ. ແຂກທີ່ຂ້າມຄຳຖາມຈະບໍ່ຖືວ່າຍິນຍອມ',
  'Ask for marketing consent': 'ຂໍຄວາມຍິນຍອມດ້ານການຕະຫຼາດ',
  'Show an opt-in question on the guest details step.': 'ສະແດງຄຳຖາມຂໍຄວາມຍິນຍອມໃນຂັ້ນຕອນຂໍ້ມູນແຂກ',
  Question: 'ຄຳຖາມ',
  'Opt-in answer': 'ຄຳຕອບຍິນຍອມ',
  'Opt-out answer': 'ຄຳຕອບບໍ່ຍິນຍອມ',

  // Confirmation
  'What happens when a guest completes a booking.': 'ສິ່ງທີ່ເກີດຂຶ້ນເມື່ອແຂກຈອງສຳເລັດ',
  'Offer add-ons': 'ສະເໜີລາຍການເສີມ',
  'Before confirmation': 'ກ່ອນຢືນຢັນ',
  'Guests add extras before they book; extras join the stay total.':
    'ແຂກເພີ່ມລາຍການເສີມກ່ອນຈອງ; ລາຍການເສີມຈະລວມໃນຍອດການພັກ',
  'After confirmation': 'ຫຼັງຢືນຢັນ',
  'Extras are offered on the confirmation page.': 'ສະເໜີລາຍການເສີມໃນໜ້າຢືນຢັນ',
  'Don’t offer': 'ບໍ່ສະເໜີ',
  'Guests book the room only.': 'ແຂກຈອງສະເພາະຫ້ອງ',
  'active services can be offered.': 'ບໍລິການທີ່ໃຊ້ງານ ສະເໜີໄດ້',
  'Manage services': 'ຈັດການບໍລິການ',
  'New online reservations': 'ການຈອງອອນລາຍໃໝ່',
  'The room is reserved immediately.': 'ຈອງຫ້ອງທັນທີ',
  'The room is held until your team confirms it.': 'ກັນຫ້ອງໄວ້ຈົນກວ່າທີມງານຂອງທ່ານຢືນຢັນ',
  'Online reservations are attributed to this source in reports.':
    'ການຈອງອອນລາຍຈະນັບເປັນຊ່ອງທາງນີ້ໃນລາຍງານ',
  'Redirect after booking': 'ສົ່ງຕໍ່ຫຼັງຈອງ',
  'Send guests to a page of your website after the confirmation page.':
    'ສົ່ງແຂກໄປໜ້າໜຶ່ງຂອງເວັບໄຊທ່ານຫຼັງໜ້າຢືນຢັນ',
  'Redirect address': 'ທີ່ຢູ່ປາຍທາງ',
  'Redirect after (seconds)': 'ສົ່ງຕໍ່ຫຼັງ (ວິນາທີ)',
  'At least 15 seconds.': 'ຢ່າງໜ້ອຍ 15 ວິນາທີ',
  'Room-nights per online booking': 'ຫ້ອງ-ຄືນຕໍ່ການຈອງອອນລາຍ',
  'Rooms × nights one online booking may hold while nothing is paid online. Larger bookings are asked to contact you.':
    'ຈຳນວນຫ້ອງ × ຄືນ ທີ່ການຈອງອອນລາຍໜຶ່ງຄັ້ງຈອງໄດ້ ໃນຂະນະທີ່ຍັງບໍ່ມີການຈ່າຍເງິນອອນລາຍ. ການຈອງທີ່ໃຫຍ່ກວ່ານີ້ຈະຖືກແນະນຳໃຫ້ຕິດຕໍ່ທ່ານ.',
  'Release unconfirmed after (hours)': 'ປ່ອຍການຈອງທີ່ຍັງບໍ່ຢືນຢັນຫຼັງ (ຊົ່ວໂມງ)',
  'Online bookings still awaiting confirmation after this many hours are cancelled and their rooms released. 0 keeps them until your team acts.':
    'ການຈອງອອນລາຍທີ່ຍັງລໍຖ້າການຢືນຢັນຫຼັງຈາກຈຳນວນຊົ່ວໂມງນີ້ ຈະຖືກຍົກເລີກ ແລະ ປ່ອຍຫ້ອງຄືນ. 0 ຈະເກັບໄວ້ຈົນກວ່າທີມງານຂອງທ່ານດຳເນີນການ.',
  'Online booking limit': 'ຂີດຈຳກັດການຈອງອອນລາຍ',
  'room-nights': 'ຫ້ອງ-ຄືນ',

  // Advanced
  'Calendar display, booking window, map and languages.':
    'ການສະແດງປະຕິທິນ, ໄລຍະເວລາຈອງ, ແຜນທີ່ ແລະ ພາສາ',
  'Guests can book an arrival for today until this time. 00:00 turns it off.':
    'ແຂກຈອງເຂົ້າພັກມື້ນີ້ໄດ້ຈົນຮອດເວລານີ້. 00:00 ຄືປິດ',
  'Bookable up to (days ahead)': 'ຈອງລ່ວງໜ້າໄດ້ເຖິງ (ມື້)',
  'Show restrictions on the calendar': 'ສະແດງຂໍ້ກຳນົດໃນປະຕິທິນ',
  'Mark closed arrivals, closed departures and minimum stays before guests choose dates.':
    'ໝາຍວັນທີ່ບໍ່ຮັບເຂົ້າພັກ, ບໍ່ຮັບອອກ ແລະ ຈຳນວນຄືນຕ່ຳສຸດ ກ່ອນແຂກເລືອກວັນທີ',
  'Show rates on the calendar': 'ສະແດງລາຄາໃນປະຕິທິນ',
  'Show the lowest standard rate under each date.': 'ສະແດງລາຄາມາດຕະຖານຕ່ຳສຸດໃຕ້ແຕ່ລະວັນທີ',
  'Show property map': 'ສະແດງແຜນທີ່ໂຮງແຮມ',
  'Show where you are at the bottom of the page.': 'ສະແດງທີ່ຕັ້ງຂອງທ່ານຢູ່ລຸ່ມສຸດຂອງໜ້າ',
  'Google Maps embed address (optional)': 'ທີ່ຢູ່ຝັງແຜນທີ່ Google Maps (ບໍ່ບັງຄັບ)',
  'In Google Maps choose Share → Embed a map and paste the src address. Empty uses your property address.':
    'ໃນ Google Maps ເລືອກ ແບ່ງປັນ → ຝັງແຜນທີ່ ແລ້ວວາງທີ່ຢູ່ src. ຖ້າວ່າງ ຈະໃຊ້ທີ່ຢູ່ໂຮງແຮມ',
  'Supported languages': 'ພາສາທີ່ຮອງຮັບ',
  'Guests choose from these languages in the booking engine header.':
    'ແຂກເລືອກພາສາເຫຼົ່ານີ້ໄດ້ຢູ່ສ່ວນຫົວຂອງໜ້າຈອງ',
  'Default language': 'ພາສາເລີ່ມຕົ້ນ',

  // Guest preview
  'Guest preview': 'ຕົວຢ່າງສຳລັບແຂກ',
  'Preview size': 'ຂະໜາດຕົວຢ່າງ',
  Mobile: 'ມືຖື',
  Desktop: 'ຄອມພິວເຕີ',
  'Expand preview': 'ຂະຫຍາຍຕົວຢ່າງ',
  'Show settings': 'ສະແດງການຕັ້ງຄ່າ',
  'Check-in': 'ເຊັກອິນ',
  'Check-out': 'ເຊັກເອົ້າ',
  Children: 'ເດັກນ້ອຍ',
  Fewer: 'ຫຼຸດ',
  More: 'ເພີ່ມ',
  'Availability calendar': 'ປະຕິທິນຫ້ອງຫວ່າງ',
  'Minimum stay': 'ຈຳນວນຄືນຕ່ຳສຸດ',
  Min: 'ຕ່ຳສຸດ',
  'All room types': 'ທຸກປະເພດຫ້ອງ',
  Recommended: 'ແນະນຳ',
  'Price: low to high': 'ລາຄາ: ຕ່ຳຫາສູງ',
  'Price: high to low': 'ລາຄາ: ສູງຫາຕ່ຳ',
  'Choose a check-out date after check-in.': 'ເລືອກວັນເຊັກເອົ້າຫຼັງວັນເຊັກອິນ',
  'Choose a stay of up to 60 nights.': 'ເລືອກການພັກບໍ່ເກີນ 60 ຄືນ',
  'Choose a check-in date from today.': 'ເລືອກວັນເຊັກອິນຕັ້ງແຕ່ມື້ນີ້',
  'This date is too far ahead to book online.': 'ວັນທີນີ້ໄກເກີນໄປທີ່ຈະຈອງອອນລາຍ',
  'Same-day bookings are closed for today.': 'ປິດການຈອງມື້ດຽວກັນສຳລັບມື້ນີ້ແລ້ວ',
  'Checking availability…': 'ກຳລັງກວດຫ້ອງຫວ່າງ…',
  'Availability could not be loaded.': 'ໂຫຼດຫ້ອງຫວ່າງບໍ່ໄດ້',
  'Up to': 'ສູງສຸດ',
  Only: 'ເຫຼືອພຽງ',
  'rooms left': 'ຫ້ອງ',
  'Sold out': 'ເຕັມແລ້ວ',
  'View offers': 'ເບິ່ງຂໍ້ສະເໜີ',
  'Hide offers': 'ເຊື່ອງຂໍ້ສະເໜີ',
  'Standard rate': 'ລາຄາມາດຕະຖານ',
  Includes: 'ລວມ',
  Book: 'ຈອງ',
  'Prices include taxes.': 'ລາຄາລວມອາກອນແລ້ວ',
  'Taxes are added at checkout.': 'ອາກອນຈະບວກເພີ່ມຕອນຊຳລະ',
  'Back to rooms': 'ກັບໄປລາຍການຫ້ອງ',
  'Add to your stay': 'ເພີ່ມໃສ່ການພັກຂອງທ່ານ',
  'First name': 'ຊື່',
  'Last name': 'ນາມສະກຸນ',
  Female: 'ຍິງ',
  Male: 'ຊາຍ',
  'I accept the terms and conditions': 'ຂ້ອຍຍອມຮັບຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂ',
  'Complete booking': 'ຈອງໃຫ້ສຳເລັດ',
  'Preview only. No reservation is created.': 'ຕົວຢ່າງເທົ່ານັ້ນ. ບໍ່ມີການສ້າງການຈອງ',
  'Your reservation is confirmed': 'ການຈອງຂອງທ່ານໄດ້ຮັບການຢືນຢັນແລ້ວ',
  'We received your reservation request': 'ພວກເຮົາໄດ້ຮັບຄຳຂໍຈອງຂອງທ່ານແລ້ວ',
  'We look forward to welcoming you.': 'ພວກເຮົາຍິນດີຕ້ອນຮັບທ່ານ',
  'We will confirm your room shortly.': 'ພວກເຮົາຈະຢືນຢັນຫ້ອງຂອງທ່ານໃນໄວໆນີ້',
  'Guests go to': 'ແຂກຈະໄປທີ່',
  after: 'ຫຼັງ',
  seconds: 'ວິນາທີ',
  'Start over': 'ເລີ່ມໃໝ່',
  'Google Maps': 'Google Maps',
  'Add your address in Property details': 'ເພີ່ມທີ່ຢູ່ຂອງທ່ານໃນຂໍ້ມູນໂຮງແຮມ',
  'Powered by LFB': 'ຂັບເຄື່ອນໂດຍ LFB',

  // Validation from the server
  'Enter a full https:// address': 'ປ້ອນທີ່ຢູ່ເຕັມທີ່ເລີ່ມດ້ວຍ https://',
  'List each room type once': 'ລະບຸແຕ່ລະປະເພດຫ້ອງຄັ້ງດຽວ',
  'Add your terms and conditions before requiring guests to accept them':
    'ເພີ່ມຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂກ່ອນບັງຄັບໃຫ້ແຂກຍອມຮັບ',
  'Enter the consent question guests will see': 'ປ້ອນຄຳຖາມຂໍຄວາມຍິນຍອມທີ່ແຂກຈະເຫັນ',
  'Enter the page guests go to after booking': 'ປ້ອນໜ້າທີ່ແຂກຈະໄປຫຼັງຈອງ',
  'Paste the src address of a Google Maps embed. It starts with https://www.google.com/maps/embed':
    'ວາງທີ່ຢູ່ src ຂອງແຜນທີ່ Google Maps ທີ່ຝັງ. ເລີ່ມດ້ວຍ https://www.google.com/maps/embed',
  'Choose each language once': 'ເລືອກແຕ່ລະພາສາຄັ້ງດຽວ',
  'The default language must be one of the supported languages':
    'ພາສາເລີ່ມຕົ້ນຕ້ອງເປັນໜຶ່ງໃນພາສາທີ່ຮອງຮັບ',
  'Choose an active booking source for online reservations':
    'ເລືອກຊ່ອງທາງການຈອງທີ່ໃຊ້ງານ ສຳລັບການຈອງອອນລາຍ',

  // Publishing (Overview)
  'Publish the booking page': 'ເປີດໜ້າຈອງອອນລາຍ',
  'Guests can book at your booking link. Turn it off to stop online bookings; existing reservations stay.':
    'ແຂກຈອງໄດ້ຜ່ານລິ້ງຈອງຂອງທ່ານ. ປິດເພື່ອຢຸດຮັບການຈອງອອນລາຍ; ການຈອງທີ່ມີຢູ່ແລ້ວຍັງຄົງຢູ່',
  'Publish the booking page and save to share this link. Until then guests see a page that is not found.':
    'ເປີດໜ້າຈອງ ແລະ ບັນທຶກ ເພື່ອແບ່ງປັນລິ້ງນີ້. ກ່ອນນັ້ນ ແຂກຈະເຫັນວ່າບໍ່ພົບໜ້າ',
  'Copy link': 'ສຳເນົາລິ້ງ',
  'Link copied': 'ສຳເນົາລິ້ງແລ້ວ',
  'Copy the link from the address above': 'ສຳເນົາລິ້ງຈາກທີ່ຢູ່ຂ້າງເທິງ',

  // Public booking page
  'Book online': 'ຈອງອອນລາຍ',
  'This booking page is not available.': 'ໜ້າຈອງນີ້ບໍ່ພ້ອມໃຫ້ບໍລິການ',
  Adults: 'ຜູ້ໃຫຍ່',
  'Arrival is closed on this date': 'ບໍ່ຮັບແຂກເຂົ້າພັກໃນວັນທີນີ້',
  'Open in Google Maps': 'ເປີດໃນ Google Maps',
  'I accept the': 'ຂ້ອຍຍອມຮັບ',
  'terms and conditions': 'ຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂ',
  'Booking…': 'ກຳລັງຈອງ…',
  'No payment is taken online. The property will contact you about any deposit.':
    'ບໍ່ມີການຊຳລະເງິນອອນລາຍ. ທີ່ພັກຈະຕິດຕໍ່ທ່ານກ່ຽວກັບເງິນມັດຈຳ',
  'No payment is taken online. The property confirms your request and contacts you about any deposit.':
    'ບໍ່ມີການຊຳລະເງິນອອນລາຍ. ທີ່ພັກຈະຢືນຢັນຄຳຂໍຂອງທ່ານ ແລະ ຕິດຕໍ່ກ່ຽວກັບເງິນມັດຈຳ',
  'Reservation number': 'ເລກການຈອງ',
  'Add to my booking': 'ເພີ່ມໃສ່ການຈອງຂອງຂ້ອຍ',
  'Add-ons added to your booking.': 'ເພີ່ມລາຍການເສີມໃສ່ການຈອງຂອງທ່ານແລ້ວ',
  'Continuing in': 'ໄປຕໍ່ໃນອີກ',
  'Book another stay': 'ຈອງການພັກອື່ນ',
  'Unable to reach the booking service. Check your connection.':
    'ບໍ່ສາມາດເຊື່ອມຕໍ່ລະບົບຈອງໄດ້. ກວດເບິ່ງການເຊື່ອມຕໍ່ຂອງທ່ານ',
  'The booking service is unavailable. Please try again.': 'ລະບົບຈອງບໍ່ພ້ອມໃຊ້ງານ. ກະລຸນາລອງໃໝ່',

  // Public booking page: answers from the server
  'Booking page not found': 'ບໍ່ພົບໜ້າຈອງ',
  'Reload the booking page and try again.': 'ໂຫຼດໜ້າຈອງໃໝ່ ແລ້ວລອງອີກຄັ້ງ',
  'This page has been open a long time. Reload it and try again.':
    'ໜ້ານີ້ເປີດໄວ້ດົນແລ້ວ. ໂຫຼດໃໝ່ ແລ້ວລອງອີກຄັ້ງ',
  'Please take a moment to review your booking, then try again.':
    'ກະລຸນາກວດເບິ່ງການຈອງຂອງທ່ານ ແລ້ວລອງອີກຄັ້ງ',
  'Your booking could not be completed.': 'ບໍ່ສາມາດຈອງໃຫ້ສຳເລັດໄດ້',
  'Enter a phone number': 'ປ້ອນເບີໂທລະສັບ',
  'Accept the terms and conditions to book': 'ຍອມຮັບຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂ ເພື່ອຈອງ',
  'Add-ons are not offered with the booking': 'ບໍ່ມີລາຍການເສີມໃຫ້ເລືອກພ້ອມການຈອງ',
  'Add-ons are not offered after booking': 'ບໍ່ມີລາຍການເສີມໃຫ້ເລືອກຫຼັງການຈອງ',
  'An add-on you chose is no longer offered. Review your booking.':
    'ລາຍການເສີມທີ່ທ່ານເລືອກບໍ່ມີໃຫ້ບໍລິການແລ້ວ. ກວດເບິ່ງການຈອງຂອງທ່ານ',
  'Online booking is not available right now. Please contact us.':
    'ຕອນນີ້ຍັງຈອງອອນລາຍບໍ່ໄດ້. ກະລຸນາຕິດຕໍ່ພວກເຮົາ',
  'This rate is no longer available. Choose another.': 'ລາຄານີ້ບໍ່ມີແລ້ວ. ກະລຸນາເລືອກລາຄາອື່ນ',
  'This room is no longer available for these dates': 'ຫ້ອງນີ້ບໍ່ຫວ່າງແລ້ວສຳລັບວັນທີເຫຼົ່ານີ້',
  'Prices changed while you were booking. Review the new total.':
    'ລາຄາປ່ຽນໄປໃນລະຫວ່າງທີ່ທ່ານຈອງ. ກະລຸນາກວດເບິ່ງຍອດລວມໃໝ່',
  'This link cannot add to the reservation.': 'ລິ້ງນີ້ບໍ່ສາມາດເພີ່ມໃສ່ການຈອງໄດ້',
  'Add-ons can be added online for 30 minutes after booking. Contact us to add more.':
    'ເພີ່ມລາຍການເສີມອອນລາຍໄດ້ພາຍໃນ 30 ນາທີຫຼັງການຈອງ. ຕິດຕໍ່ພວກເຮົາເພື່ອເພີ່ມອີກ',
  'Add-ons were already added to this booking. Contact us to change them.':
    'ການຈອງນີ້ມີລາຍການເສີມແລ້ວ. ຕິດຕໍ່ພວກເຮົາເພື່ອປ່ຽນແປງ',
  'This reservation can no longer be changed online. Contact us.':
    'ການຈອງນີ້ປ່ຽນແປງອອນລາຍບໍ່ໄດ້ແລ້ວ. ກະລຸນາຕິດຕໍ່ພວກເຮົາ',
  'Send an Idempotency-Key header with each booking attempt':
    'ສົ່ງ Idempotency-Key header ກັບການຈອງແຕ່ລະຄັ້ງ',
  'This retry key belongs to a different request': 'ລະຫັດລອງໃໝ່ນີ້ເປັນຂອງຄຳຂໍອື່ນ',
  'Too many attempts. Please wait a few minutes and try again.':
    'ພະຍາຍາມຫຼາຍເກີນໄປ. ກະລຸນາລໍຖ້າຈັກໜ້ອຍ ແລ້ວລອງໃໝ່',
  'Choose each add-on once': 'ເລືອກລາຍການເສີມແຕ່ລະອັນພຽງເທື່ອດຽວ',
};
